import { saveEventEnrichments as apiSaveEventEnrichments } from 'api/integration'
import { saveEventEnrichments as saveEventEnrichmentsToIntegration } from 'redux/modules/integrations'

export const saveAll = (integrationName, eventEnrichments) => async (dispatch, getState) => {
  const projectId = getState().project.id
  await dispatch(apiSaveEventEnrichments(projectId, integrationName, eventEnrichments))
  dispatch(saveEventEnrichmentsToIntegration(integrationName, eventEnrichments))
}
